import { Spin } from "antd"
export default function LoadingSpin() {
    return <div style={{ flex: 1, justifyContent: 'center', alignItems: 'center', display: 'flex', }}>
        <Spin size="large" />

    </div>
}